function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import { useTable } from "react-table";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { MONTHLY_ATTENDANCE_QUERY, GET_USER_LISTING_QUERY, MONTHLY_ATTENDANCE_EXPORT_QUERY } from "./query";
import { useQuery, useLazyQuery, useApolloClient } from "@apollo/client";
import "./MonthlyAttendance.css";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Badge from "react-bootstrap/Badge";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { isRateLimited } from "../utils";
import Table from "react-bootstrap/Table";
import classNames from "classnames";
var LIMIT = 11;
var offsets = 0;
var MonthlyAttendance = function MonthlyAttendance(props) {
  var _userListData$getUser, _monthlyReportData$mo5, _monthlyReportData$mo7;
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  var client = useApolloClient();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isExporting = _React$useState2[0],
    setIsExporting = _React$useState2[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _React$useState3 = React.useState(new Date()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    date = _React$useState4[0],
    setDate = _React$useState4[1];
  var _React$useState5 = React.useState({
      label: "All Members",
      value: null
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    userParameterCheck = _React$useState6[0],
    setUserParameterCheck = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoaded = _React$useState8[0],
    setIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMore = _React$useState10[0],
    setIsLoadingMore = _React$useState10[1];
  var dateMoment = moment(date);
  var userList = [{
    label: "All Members",
    value: null
  }];
  React.useEffect(function () {
    setIsAllLoaded(false);
    setIsLoadingMore(false);
  }, [date, userParameterCheck]);
  var _useQuery = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery.loading,
    userListData = _useQuery.data,
    userListError = _useQuery.error;
  var _useQuery2 = useQuery(MONTHLY_ATTENDANCE_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck.value,
        startTime: Number(moment(dateMoment).startOf("month").format("x")),
        endTime: Number(moment(dateMoment).endOf("month").format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        userRole: role,
        workingDays: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.workingDays
      },
      skip: !organisationId || !teamId
    }),
    monthlyReportLoading = _useQuery2.loading,
    monthlyReportData = _useQuery2.data,
    monthlyReportError = _useQuery2.error,
    monthlyReportFetchMore = _useQuery2.fetchMore;
  React.useEffect(function () {
    if (userParameterCheck === null) {
      setUserParameterCheck({
        label: "All Members",
        value: null
      });
    }
  }, [userListData]);
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  React.useEffect(function () {
    var _monthlyReportData$mo, _monthlyReportData$mo2, _monthlyReportData$mo3, _monthlyReportData$mo4;
    if ((monthlyReportData === null || monthlyReportData === void 0 ? void 0 : (_monthlyReportData$mo = monthlyReportData.monthlyAttendance) === null || _monthlyReportData$mo === void 0 ? void 0 : (_monthlyReportData$mo2 = _monthlyReportData$mo.userData) === null || _monthlyReportData$mo2 === void 0 ? void 0 : _monthlyReportData$mo2.length) !== 0 && (monthlyReportData === null || monthlyReportData === void 0 ? void 0 : (_monthlyReportData$mo3 = monthlyReportData.monthlyAttendance) === null || _monthlyReportData$mo3 === void 0 ? void 0 : (_monthlyReportData$mo4 = _monthlyReportData$mo3.userData) === null || _monthlyReportData$mo4 === void 0 ? void 0 : _monthlyReportData$mo4.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [monthlyReportData === null || monthlyReportData === void 0 ? void 0 : monthlyReportData.monthlyAttendance]);
  React.useEffect(function () {
    setIsAllLoaded(false);
  }, [userParameterCheck]);
  var headers = [];
  var monthlyReportTableData = [];
  if (monthlyReportData !== null && monthlyReportData !== void 0 && (_monthlyReportData$mo5 = monthlyReportData.monthlyAttendance) !== null && _monthlyReportData$mo5 !== void 0 && _monthlyReportData$mo5.headerData) {
    var _monthlyReportData$mo6;
    headers = [{
      Header: "Employees",
      accessor: "employee"
    }, {
      Header: "Total Days in Month",
      accessor: "totalDays"
    }, {
      Header: "Office Days",
      accessor: "totalWorkingDays"
    }, {
      Header: "Clock-In Days Count",
      accessor: "totalPresent"
    }, {
      Header: "Worked Days",
      accessor: "totalWorkedDays"
    }, {
      Header: "Week-off & Holidays Count",
      accessor: "nonWorkingDaysAndHolidays"
    }, {
      Header: "Days Worked in Week-off & Holidays",
      accessor: "workedDaysInHolidays"
    }, {
      Header: "Informed Leave Count",
      type: "informedLeaveCounts",
      columns: [{
        Header: "Total Leave",
        accessor: "informedLeaveCount"
      }, {
        Header: "Paid Leave",
        accessor: "informedPaidLeaveCount"
      }, {
        Header: "Unpaid Leave",
        accessor: "informedUnpaidLeaveCount"
      }]
      //accessor: "informedLeaveCount",
    }, {
      Header: "Absent Leave	Count",
      accessor: "uninformedLeaveCount"
    }, {
      Header: "Total Worked Time",
      accessor: "totalWorkedTime"
    }, {
      Header: "Total Active Time",
      accessor: "totalActiveTime"
    }, {
      Header: "Avg Worked Time",
      accessor: "avgWorkedTime"
    }].concat(_toConsumableArray(monthlyReportData === null || monthlyReportData === void 0 ? void 0 : (_monthlyReportData$mo6 = monthlyReportData.monthlyAttendance) === null || _monthlyReportData$mo6 === void 0 ? void 0 : _monthlyReportData$mo6.headerData));
  }
  var getExportData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var totalUsersExport, offset, limit, hasMore, _yield$client$query, data, userData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setIsExporting(true);
            totalUsersExport = [];
            offset = 0;
            limit = 50;
            hasMore = true;
          case 6:
            if (!hasMore) {
              _context.next = 16;
              break;
            }
            _context.next = 9;
            return client.query({
              query: MONTHLY_ATTENDANCE_EXPORT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userParameterCheck.value,
                startTime: Number(moment(dateMoment).startOf("month").format("x")),
                endTime: Number(moment(dateMoment).endOf("month").format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                userRole: role,
                workingDays: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.workingDays,
                limit: limit,
                offset: offset,
                // Continuations of one batched export. The API charges only the
                // opening request against the export rate limit.
                isBatch: offset > 0
              },
              fetchPolicy: "network-only"
            });
          case 9:
            _yield$client$query = _context.sent;
            data = _yield$client$query.data;
            userData = (data === null || data === void 0 ? void 0 : data.monthlyAttendanceExport) || [];
            totalUsersExport.push.apply(totalUsersExport, _toConsumableArray(userData));
            if (userData.length < limit || userParameterCheck.value !== null) {
              hasMore = false;
            } else {
              offset += limit;
            }
            _context.next = 6;
            break;
          case 16:
            if (!(totalUsersExport.length > 0)) {
              _context.next = 19;
              break;
            }
            _context.next = 19;
            return csvData(totalUsersExport);
          case 19:
            setIsExporting(false);
            _context.next = 27;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](0);
            console.error("Export error:", _context.t0);

            // A 429 is already toasted by the errorLink in apollo/apollo-config.js,
            // which reads the export limiter's own message out of the response body.
            // Everything else was silent: the spinner stopped, no file arrived, and
            // the button looked like it had done nothing.
            if (!isRateLimited(_context.t0)) {
              toast.error("Export failed. Please try again.");
            }
            setIsExporting(false);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 22]]);
    }));
    return function getExportData() {
      return _ref.apply(this, arguments);
    };
  }();
  var csvData = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dataValues) {
      var _dataValues$;
      var wb, ws, col, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (dataValues) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", []);
          case 2:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            col = [{
              header: "Employee",
              key: "employee",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Employee ID",
              key: "employeeId",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Total Days in Month",
              key: "totalDays",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Office Days (Excluding weekends & holidays)",
              key: "totalWorkingDays",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Clock-In Days Count",
              key: "totalPresent",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Worked Days",
              key: "totalWorkedDays",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Week-off & Holidays Count",
              key: "nonWorkingDaysAndHolidays",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Days Worked in Week-off & Holidays",
              key: "workedDaysInHolidays",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Informed Leave Count",
              key: "informedLeaveCount",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Informed Paid Leave Count",
              key: "informedPaidLeaveCount",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Informed Unpaid Leave Count",
              key: "informedUnpaidLeaveCount",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Absent Leave	Count",
              key: "uninformedLeaveCount",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Total Worked Time",
              key: "totalWorkedTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Total Active Time",
              key: "totalActiveTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Avg Worked Time",
              key: "avgWorkedTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            (_dataValues$ = dataValues[0]) === null || _dataValues$ === void 0 ? void 0 : _dataValues$.day.map(function (dTemp) {
              var date = dTemp.dateValue,
                clockIn = dTemp.clockIn;
              col.push({
                header: "".concat(date, " (Status)"),
                key: "".concat(date, " (Status)"),
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              col.push({
                header: "".concat(date, " (Total Time)"),
                key: "".concat(date, " (Total Time)"),
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              col.push({
                header: "".concat(date, " (Active Time)"),
                key: "".concat(date, " (Active Time)"),
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            });
            ws.columns = col;
            dataValues.map(function (user, index) {
              var day = user.day,
                employee = user.employee,
                totalAbsent = user.totalAbsent,
                totalLeave = user.totalLeave,
                totalPresent = user.totalPresent,
                employeeId = user.employeeId,
                totalWorkedTime = user.totalWorkedTime,
                uninformedLeaveCount = user.uninformedLeaveCount,
                informedLeaveCount = user.informedLeaveCount,
                informedPaidLeaveCount = user.informedPaidLeaveCount,
                informedUnpaidLeaveCount = user.informedUnpaidLeaveCount,
                nonWorkingDaysAndHolidays = user.nonWorkingDaysAndHolidays,
                workedDaysInHolidays = user.workedDaysInHolidays,
                totalActiveTime = user.totalActiveTime,
                totalWorkedDays = user.totalWorkedDays,
                totalDays = user.totalDays,
                totalWorkingDays = user.totalWorkingDays,
                avgTotalTime = user.avgTotalTime;
              var monthlyReportTableDayData = {};
              day.map(function (dTemp) {
                var dateValue = dTemp.dateValue,
                  data = dTemp.data,
                  value = dTemp.value;
                var statusHeader = "".concat(dateValue, " (Status)");
                var totalTimeHeader = "".concat(dateValue, " (Total Time)");
                var activeTimeHeader = "".concat(dateValue, " (Active Time)");
                monthlyReportTableDayData = _objectSpread(_objectSpread({}, monthlyReportTableDayData), {}, _defineProperty(_defineProperty(_defineProperty({}, statusHeader, data.status), totalTimeHeader, data.totalTime), activeTimeHeader, data.activeTime));
              });
              ws.addRow(_objectSpread({
                employee: employee,
                employeeId: employeeId,
                totalPresent: totalPresent,
                totalWorkedDays: totalWorkedDays,
                totalAbsent: totalAbsent,
                totalWorkedTime: totalWorkedTime,
                totalActiveTime: totalActiveTime,
                uninformedLeaveCount: uninformedLeaveCount,
                informedLeaveCount: informedLeaveCount,
                informedPaidLeaveCount: informedPaidLeaveCount,
                informedUnpaidLeaveCount: informedUnpaidLeaveCount,
                nonWorkingDaysAndHolidays: nonWorkingDaysAndHolidays,
                workedDaysInHolidays: workedDaysInHolidays,
                avgWorkedTime: avgTotalTime,
                totalWorkingDays: totalWorkingDays,
                totalDays: totalDays
              }, monthlyReportTableDayData));
            });
            ws.getRow(1).font = {
              bold: true
            };
            _context2.next = 11;
            return wb.xlsx.writeBuffer();
          case 11:
            buf = _context2.sent;
            fileName = "workfolio-monthly-attendance-".concat(moment(date).format("MMMM yyyy"), ".xlsx");
            saveAs(new Blob([buf]), fileName);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [date]);

  // React.useEffect(() => {
  //   csvData();
  // }, [exportData]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "employee-report-root-card"
  }, /*#__PURE__*/React.createElement(TableGrid, {
    date: date,
    setDate: setDate,
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    headers: headers,
    monthlyReportTableData: monthlyReportData === null || monthlyReportData === void 0 ? void 0 : (_monthlyReportData$mo7 = monthlyReportData.monthlyAttendance) === null || _monthlyReportData$mo7 === void 0 ? void 0 : _monthlyReportData$mo7.userData,
    userList: userList,
    monthlyReportFetchMore: monthlyReportFetchMore,
    monthlyReportLoading: monthlyReportLoading,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    monthlyReportData: monthlyReportData,
    getExportData: getExportData,
    exportLoading: isExporting,
    organisationBilling: organisationBilling
  })));
};
var TableGrid = function TableGrid(props) {
  var date = props.date,
    setDate = props.setDate,
    userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    headers = props.headers,
    monthlyReportTableData = props.monthlyReportTableData,
    userList = props.userList,
    monthlyReportFetchMore = props.monthlyReportFetchMore,
    monthlyReportLoading = props.monthlyReportLoading,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    monthlyReportData = props.monthlyReportData,
    getExportData = props.getExportData,
    exportLoading = props.exportLoading,
    organisationBilling = props.organisationBilling;
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoaderMoreButtonLoading = _React$useState12[0],
    setLoadMoreButtonLoading = _React$useState12[1];
  var data = monthlyReportTableData;
  var columns = headers;

  // const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
  //   columns,
  //   data,
  // });

  var handleLoadMore = function handleLoadMore() {
    var _monthlyReportData$mo8, _monthlyReportData$mo9;
    if (monthlyReportLoading) return;
    setIsLoadingMore(true);
    monthlyReportFetchMore({
      variables: {
        offset: monthlyReportData === null || monthlyReportData === void 0 ? void 0 : (_monthlyReportData$mo8 = monthlyReportData.monthlyAttendance) === null || _monthlyReportData$mo8 === void 0 ? void 0 : (_monthlyReportData$mo9 = _monthlyReportData$mo8.userData) === null || _monthlyReportData$mo9 === void 0 ? void 0 : _monthlyReportData$mo9.length
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var _fetchMoreResult$mont, _fetchMoreResult$mont2, _fetchMoreResult$mont3, _fetchMoreResult$mont4, _prev$monthlyAttendan, _fetchMoreResult$mont5;
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$mont = fetchMoreResult.monthlyAttendance) === null || _fetchMoreResult$mont === void 0 ? void 0 : (_fetchMoreResult$mont2 = _fetchMoreResult$mont.userData) === null || _fetchMoreResult$mont2 === void 0 ? void 0 : _fetchMoreResult$mont2.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$mont3 = fetchMoreResult.monthlyAttendance) === null || _fetchMoreResult$mont3 === void 0 ? void 0 : (_fetchMoreResult$mont4 = _fetchMoreResult$mont3.userData) === null || _fetchMoreResult$mont4 === void 0 ? void 0 : _fetchMoreResult$mont4.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          monthlyAttendance: _objectSpread(_objectSpread({}, prev.monthlyAttendance), {}, {
            userData: [].concat(_toConsumableArray((_prev$monthlyAttendan = prev.monthlyAttendance) === null || _prev$monthlyAttendan === void 0 ? void 0 : _prev$monthlyAttendan.userData), _toConsumableArray((_fetchMoreResult$mont5 = fetchMoreResult.monthlyAttendance) === null || _fetchMoreResult$mont5 === void 0 ? void 0 : _fetchMoreResult$mont5.userData))
          })
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "monthly-attendence-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-date-picker"
  }, " ", /*#__PURE__*/React.createElement(DatePicker, {
    selected: date,
    onChange: function onChange(dateValue) {
      return setDate(dateValue);
    },
    dateFormat: "MMMM yyyy",
    showMonthYearPicker: true,
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? moment().startOf("month").toDate() : null
  }))), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement(Button, {
    className: "monthly-attendence-download-export-button",
    variant: "outline-primary",
    onClick: function onClick() {
      return getExportData();
    }
  }, " ", exportLoading ? "Downloading" : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiDownload, {
    className: "monthly-attendence-download-icon"
  }), " Export")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export")))), /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-content"
  }, monthlyReportLoading ? /*#__PURE__*/React.createElement(Loader, null) : !monthlyReportData ? /*#__PURE__*/React.createElement("div", null, "No data") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    className: "monthly-in-out-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "monthly-in-out-content-table-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "monthly-in-out-content-table-thead-table-row"
  }, columns.map(function (employeeHeader, index) {
    return /*#__PURE__*/React.createElement("th", {
      colSpan: employeeHeader.type == "date" ? 3 : employeeHeader.type == "informedLeaveCounts" ? 3 : 1,
      key: "header-".concat(index),
      className: index == 0 ? "monthly-in-out-content-sticky-col first-col" : "",
      rowSpan: employeeHeader.type != "date" && employeeHeader.type != "informedLeaveCounts" ? 3 : 1
    }, employeeHeader.Header);
  })), /*#__PURE__*/React.createElement("tr", {
    className: "monthly-in-out-content-table-thead-table-row"
  }, columns.map(function (employeeHeader, index) {
    return employeeHeader.columns && employeeHeader.columns.length > 0 && employeeHeader.columns.length == 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
      key: "header-status-".concat(index)
    }, employeeHeader.columns[0].Header), /*#__PURE__*/React.createElement("th", {
      key: "header-in-".concat(index)
    }, employeeHeader.columns[1].Header), /*#__PURE__*/React.createElement("th", {
      key: "header-out-".concat(index)
    }, employeeHeader.columns[2].Header)) : employeeHeader.columns && employeeHeader.columns.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
      key: "total-status-".concat(index)
    }, employeeHeader.columns[0].Header), /*#__PURE__*/React.createElement("th", {
      key: "paid-in-".concat(index)
    }, employeeHeader.columns[1].Header), /*#__PURE__*/React.createElement("th", {
      key: "unpaid-out-".concat(index)
    }, employeeHeader.columns[2].Header)) : /*#__PURE__*/React.createElement(React.Fragment, null);
  }))), /*#__PURE__*/React.createElement("tbody", {
    className: "monthly-attendance-table-tbody"
  }, data.map(function (employeeData, index) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      key: "index",
      className: "monthly-in-out-content-sticky-col first-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "daily-attendance-tr-table-grid-employee-displayname-wrapper"
    }, employeeData.profileUrl ? /*#__PURE__*/React.createElement("div", {
      "class": "monthly-in-out-table-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: employeeData.profileUrl,
      "class": "monthly-in-out-table-card-avatar-profile-img"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "daily-attendance-tr-table-grid-employee-avatar-circle text-white"
    }, employeeData.employee.charAt(0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: !employeeData.employeeId ? "daily-attendance-tr-table-grid-employee-name" : ""
    }, employeeData.employee), employeeData.employeeId ? /*#__PURE__*/React.createElement("div", {
      className: "daily-attendance-tr-table-grid-employee-id"
    }, "Emp ID: ", employeeData.employeeId) : ""))), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalDays), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalWorkingDays), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalPresent), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalWorkedDays), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.nonWorkingDaysAndHolidays), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.workedDaysInHolidays), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.informedLeaveCount), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.informedPaidLeaveCount), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.informedUnpaidLeaveCount), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.uninformedLeaveCount), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalWorkedTime), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalActiveTime), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.avgTotalTime), employeeData.day.map(function (employeeDate, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
        //className="monthly-in-out-content-table-tbody-td-status"
        className: classNames("monthly-in-out-content-table-tbody-td-status", {
          "monthly-in-out-content-table-tbody-td-status-present": employeeDate.data.status == "Present"
        }, {
          "monthly-in-out-content-table-tbody-td-status-weekoff": employeeDate.data.status == "Weekoff"
        }, {
          "monthly-in-out-content-table-tbody-td-status-half": employeeDate.data.status == "Half Day Leave & Present"
        })
      }, employeeDate.data.status), employeeDate.value !== "" ? /*#__PURE__*/React.createElement("td", {
        colSpan: 2,
        className: classNames("monthly-in-out-content-table-tbody-td-absent", {
          "monthly-in-out-content-table-tbody-td-status-weekoff": employeeDate.data.status == "Weekoff"
        })
      }, employeeDate.value === "-" ? "" : employeeDate.value) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
        className: classNames({
          "monthly-in-out-content-table-tbody-td-status-present": employeeDate.data.status == "Present"
        }, {
          "monthly-in-out-content-table-tbody-td-status-half": employeeDate.data.status == "Half Day Leave & Present"
        })
      }, employeeDate.data.totalTime), /*#__PURE__*/React.createElement("td", {
        className: classNames({
          "monthly-in-out-content-table-tbody-td-status-present": employeeDate.data.status == "Present"
        }, {
          "monthly-in-out-content-table-tbody-td-status-half": employeeDate.data.status == "Half Day Leave & Present"
        })
      }, employeeDate.data.activeTime)));
    }));
  })))), !monthlyReportLoading && monthlyReportData && monthlyReportData.length != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users")) : null)));
};
export default MonthlyAttendance;